module.exports = __webpack_public_path__ + "ed349b703093de7614b3e44fea4142d4.svg";